import { useState } from "react";
import { Output } from "valibot";

import { LocaleSchema } from "shared/schemas";

import { BaseBubble } from "./BaseBubble";
import InputComponent from "./InputComponent";
export type MessageType =
  | "string"
  | "number"
  | "email"
  | "file_url"
  | "date"
  | "phone_number"
  | "text_area"
  | "text_only";
export interface IMessageProps {
  id: string;
  label?: string;
  isSubmittable?: boolean;
  type: MessageType;
  value: string;
  onSubmit?: (
    id: string,
    value: string,
  ) => Promise<void | Error> | void | Error;
  isNonEditable?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  generationLanguage: Output<typeof LocaleSchema>;
  isDisabled?: boolean;
}

export function Message(props: IMessageProps) {
  const {
    id,
    type,
    value: val,
    isNonEditable,
    isRequired,
    placeholder,
    generationLanguage,
    onSubmit,
    isDisabled,
    label,
  } = props;
  const [value, setInputValues] = useState<string>(val);
  const [errorMessage, setErrorMessage] = useState<string | null>();
  const [isloading, setIsloading] = useState<boolean>(false);

  const handleSetValue = (inptVal: string) => {
    setInputValues(inptVal);
    setErrorMessage(null);
  };

  const handleOnSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsloading(true);
    if (onSubmit) {
      // if return something means there is an error
      const errorObj = await onSubmit(id, value);
      if (errorObj) {
        setErrorMessage(errorObj.message);
      }
      setIsloading(false);
    }
  };

  if (type === "text_only") {
    return (
      <BaseBubble isTextOnly>
        <p>{value}</p>
      </BaseBubble>
    );
  }
  if (isNonEditable) {
    return (
      <BaseBubble key={id} type={value ? "done" : "disabled"} label={label}>
        <InputComponent
          id={id}
          generationLanguage={generationLanguage}
          type={type}
          value={value || ""}
          disabled={true}
        />
      </BaseBubble>
    );
  }

  return (
    <form onSubmit={handleOnSubmit}>
      <BaseBubble
        errorMessage={errorMessage}
        isLoading={isloading}
        label={label}
        type={isDisabled ? "disabled" : "default"}
        isSkipable={!isRequired}
        isTextArea={type === "text_area"}
      >
        <InputComponent
          id={id}
          generationLanguage={generationLanguage}
          type={type}
          value={value || ""}
          disabled={isloading}
          setInputValues={handleSetValue}
          isRequired={isRequired ?? false}
          placeholder={placeholder ?? ""}
        />
      </BaseBubble>
    </form>
  );
}
